import Recipe from '@/modules/recipe/domain/recipe'

export default class RecipeAmount {
  recipe: Recipe | null = null
  amount: number | null = null
}
